// extracted by mini-css-extract-plugin
export default {"existBadge":"ApprovalNotificationDot_existBadge__XrVMS"};